import React from "react"
import { Box } from "@mui/system"
import { Grid, Typography } from "@mui/material"
import PropTypes from "prop-types"
import theme from "../../../../theme/theme"

const InfoItem = ({ label, value, optionalText }) => {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            <Typography
                variant="contraHeading"
                sx={{ color: theme.palette.primary.white70 }}
            >
                {label}
            </Typography>
            <Typography
                variant="textBody"
                color="common.white"
                sx={{ whiteSpace: "pre-line" }}
            >
                {value}
            </Typography>
            {optionalText && (
                <Typography
                    variant="contraHeading"
                    color="common.white"
                    sx={{ opacity: "70%" }}
                >
                    {optionalText}
                </Typography>
            )}
        </Box>
    )
}

InfoItem.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    optionalText: PropTypes.string,
}
export const BoxCreditEmission = ({ characterData }) => {
    const formatCPFCNPJ = (value) => {
        if (!value) return "-"

        const digits = value.replace(/\D/g, "")
        if (digits.length === 11) {
            return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
        }
        if (digits.length === 14) {
            return digits.replace(
                /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                "$1.$2.$3/$4-$5"
            )
        }
        return value
    }

    return (
        <Box display="flex" gap={3} flexDirection="column">
            <Typography variant="h3" color="common.white">
                Info de crédito e contraparte
            </Typography>

            <Box
                sx={{
                    p: 3,
                    background:
                        "linear-gradient(90.8deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 100%)",
                }}
            >
                <Grid container rowSpacing={3}  sx={{
                            display: "flex",
                            flexDirection: { xxxs: "column", xs: "row" },
                           
                        }}>
                    <Grid item xxxs={2} sm={2} md sx={{pr: 2}}>
                        <InfoItem
                            label="Agente Fiduciário"
                            value={characterData?.AgenteFiduciario ?? "-"}
                        />
                    </Grid>

                    <Grid item xxxs={2} sm={2} md sx={{pr: 2}}>
                        <InfoItem
                            label="Cedente"
                            value={characterData?.Cedente ?? "-"}
                        />
                    </Grid>

                    <Grid item xxxs={2} sm={2} md sx={{pr: 2}}>
                        <InfoItem
                            label="Devedor"
                            value={characterData?.Devedor ?? "-"}
                            optionalText={`CNPJ. ${formatCPFCNPJ(characterData?.CPF_CNPJ_Devedor)}`}
                        />
                    </Grid>

                    <Grid item xxxs={2} sm={2} md sx={{pr: 2}}>
                        <InfoItem
                            label="Grupo Econômico"
                            value={characterData?.GrupoEconomico ?? "-"}
                            optionalText={`RAÍZ CNPJ. ${characterData?.CNPJGrupoEconomico ?? "-"}`}
                        />
                    </Grid>

                    <Grid item xxxs={4} md>
                        <InfoItem
                            label="Setor e Subsetor"
                            value={`${characterData?.Setor ?? "-"} / ${characterData?.SubSetor ?? "-"}`}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    )
}

BoxCreditEmission.propTypes = {
    characterData: PropTypes.shape({
        AgenteFiduciario: PropTypes.string,
        Cedente: PropTypes.string,
        Devedor: PropTypes.string,
        GrupoEconomico: PropTypes.string,
        Setor: PropTypes.string,
        SubSetor: PropTypes.string,
        CNPJGrupoEconomico: PropTypes.string,
        CPF_CNPJ_Devedor: PropTypes.string,
    }),
}
